module.exports = __webpack_public_path__ + "static/media/illustration-signal.2db6aae0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/illustration-signal.svg
// module id = 1927
// module chunks = 0